<template>
<Layout>
    <div class="flex flex-col items-center justify-center min-h-36 md:min-h-96 mt-10">
        <div class="lg:w-4/5 mx-auto bg-base-200 my-2 md:my-10">
        <masonry :cols="{default: 2, 1000: 3, 700: 2, 400: 1}" :gutter="0">
                <div class="m-1" v-for="(image, i) in images" :key="i" @click="index = i">
                    <img class="image object-cover" :src="image">
                </div>
        </masonry>
        </div>
        <vue-gallery-slideshow :images="images" :index="index" @close="index = null"></vue-gallery-slideshow>
    </div>
</Layout>
</template>

<script>
import Layout from '../components/Layout.vue';
import VueGallerySlideshow from 'vue-gallery-slideshow';

const patternCount = 32;
let patternImages = [];
for (let i = 1; i < patternCount; i++) {
    patternImages.push(require(`../assets/lifestyle/image${i}.jpeg`));
}
export default {
    name: 'LifestylePage',
    components: {
        Layout,
        VueGallerySlideshow
    },
    data() {
        return {
            images: patternImages,
            index: null
        }
    }
}
</script>

<style>
/* .vgs__container {
    height: auto !important;
} */
</style>